import { render, staticRenderFns } from "./FooterToolBar.vue?vue&type=template&id=5028374f&scoped=true"
import script from "./FooterToolBar.vue?vue&type=script&lang=js"
export * from "./FooterToolBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5028374f",
  null
  
)

export default component.exports